import { Box, Collapse, IconButton, Table, TableCell, TableRow, TableHead, TableBody, Typography } from "@material-ui/core";
import React, { ReactNode, SetStateAction, useEffect } from "react";
import { useState } from "react";
import { BsFileText } from "react-icons/bs";
import { HiOutlineClipboardCheck } from 'react-icons/hi';
import { GiCancel } from 'react-icons/gi'
import { usePedidos } from "../../../../contexts/Pedidos";
import ReactLoading from 'react-loading';
import { useModals } from "../../../../contexts/Modals";
import { TextOnlyTooltip } from "../../../../themes/components/TextOnlyTooltip";
import { Button } from "../../../../themes/components/Button";
import $ from 'jquery';
interface HistPedido {
    evento: [
        {
            dateve: string,
            deseve: string,
            esteve: string,
            horeve: string
        }]
}

interface arrayHistPedidos {
    length: number;
    [index: number]: HistPedido
}

export function RowListaPedidosAprov(props: {
    row: ReturnType<any>,
    handleModal: (numped: number, codemp: string) => void,
    history: ReturnType<any>,
    index: number,
    setOrderBy: React.Dispatch<SetStateAction<string>>
}) {
    const { row, handleModal, history } = props;
    const { mostrarInfoOK, setMensagem, setShowModalInfo } = useModals();
    const { buscarHistoricoPed, controleAprovacao, filtrarPedidosAprovacao } = usePedidos();
    const [open, setOpen] = useState(false);
    const [localHistorico, setLocalHistorico] = useState<arrayHistPedidos>([]);
    const [localLoading, setLocalLoading] = useState(true);

    function confirmaAprovacao() {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{`Deseja aprovar o pedido ${row.numPed} ?`}</Typography>
                <Typography>{`Observação:`}</Typography>
                <textarea name="obs-aprov" cols={4} rows={5} id="obs-aprov" style={{ height: '5em', border: '2px solid #ccc', borderRadius: '5px', fontSize: '0.9em', marginRight: '1em', marginBottom: '1em', width: '600px', whiteSpace: 'break-spaces' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-default"}>Fechar</Button>
                    <Button onClick={() => [setShowModalInfo(false), registrarAprovacao()]} classBtn={"btn-notifications color-green"}>Sim</Button>
                </div>
            </div>);
        setShowModalInfo(true);
    }

    function confirmaCancelamento() {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{`Deseja cancelar o pedido ${row.numPed} ?`}</Typography>
                <Typography>{`Observação:`}</Typography>
                <textarea name="obs-aprov" cols={4} rows={5} id="obs-aprov" style={{ height: '5em', border: '2px solid #ccc', borderRadius: '5px', fontSize: '0.9em', marginRight: '1em', marginBottom: '1em', width: '600px', whiteSpace: 'break-spaces' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-default"}>Fechar</Button>
                    <Button onClick={() => [setShowModalInfo(false), registrarCancelamento()]} classBtn={"btn-notifications color-red"}>Sim</Button>
                </div>
            </div>);
        setShowModalInfo(true);
    }

    function registrarAprovacao() {

       // console.log(("num ped: "+row.numPed+ " CodEmp: "+row.codEmp+ " ObsAprove: "+document.getElementById("obs-aprov")+ " Tipo: "+"A"+ " History: "+history));
      $(function () {
            let obsAprov = (document.getElementById("obs-aprov") as HTMLInputElement)?.value;
            controleAprovacao(row.numPed, row.codEmp, obsAprov, "A", history)
                .then(res => {
                    props.setOrderBy("pedido");
                    filtrarPedidosAprovacao("", "", row.codEmp, "", "", history);
                    mostrarInfoOK(res);
                })
                .catch(err => {
                    mostrarInfoOK(err);
                })
        })
    }

    function registrarCancelamento() {
        let obsAprov = (document.getElementById("obs-aprov") as HTMLInputElement)?.value;
        controleAprovacao(row.numPed, row.codEmp, obsAprov, "C", history)
            .then(res => {
                props.setOrderBy("pedido");
                filtrarPedidosAprovacao("", "", row.codEmp, "", "", history);
                mostrarInfoOK(res);
            })
            .catch(err => {
                mostrarInfoOK(err);
            })
    }

    useEffect(() => {
        async function teste() {
            let hist = await buscarHistoricoPed(row.numPed, row.codemp, history)
            setLocalHistorico(hist);
            setLocalLoading(false);
        }
        if (open === true) {
            setLocalLoading(true);
            teste();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);


    return (
        <React.Fragment>
            <TableRow className={`linha_${props.index % 2 === 0 ? "par" : "impar"}`}>
                <TableCell scope="row" style={{ border: 'none', display: "flex", justifyContent: "row", padding: "0px" }} ><div style={{ backgroundColor: row.codEmp == 2 ? "#0252a8" : row.codEmp == 4 ? "#FF4800" : row.codEmp, width: "5px", height: "85px", margin: "0px 10px 0px 0px" }}></div><div style={{ margin: "33px 0px 0px 0px" }}>{row.numPed}</div></TableCell>
                <TableCell align="left" style={{ border: 'none' }} >{row.nomCli}</TableCell>
                <TableCell align="left" style={{ border: 'none' }} >{(row.codEmp =="2" ? "GA" : row.codEmp =="4" ? "AB" : row.codEmp)}</TableCell>
                <TableCell align="center" style={{ border: 'none' }} >{row.datEmi}</TableCell>
                <TableCell align="center" style={{ border: 'none' }} >{row.datPrv}</TableCell>
                <TableCell align="right" style={{ border: 'none' }} >{parseFloat(row.qtdOri).toLocaleString('pt-br', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                <TableCell align="right" style={{ border: 'none' }} >{parseFloat(row.vlrOri).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</TableCell>
                <TableCell align="right" width="50px" style={{ border: 'none' }} >
                    <TextOnlyTooltip title="Detalhes" placement="top">
                        <button style={{ backgroundColor: 'transparent', border: '0px' }} onClick={() => handleModal(row.numPed, row.codEmp)} >
                            <BsFileText size="22" color={"#003388"} />
                        </button>
                    </TextOnlyTooltip>
                </TableCell>
                <TableCell width="50px" style={{ border: 'none', textAlign: 'center' }} ><IconButton onClick={() => confirmaAprovacao()}><HiOutlineClipboardCheck size="25" color="green" /></IconButton></TableCell>
                <TableCell width="50px" style={{ border: 'none', textAlign: 'center' }} ><IconButton onClick={() => confirmaCancelamento()}><GiCancel size="21" color="red" /></IconButton></TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: '1px solid #ccc' }} colSpan={9}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        {localLoading ?
                            <div style={{ display: 'flex', marginBottom: "2em", alignItems: 'center', justifyContent: 'center' }}>
                                <ReactLoading type={"bars"} color={"#0252a8"} height={25} width={50} />
                            </div>
                            :
                            <Box margin={1}>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Andamento do Pedido</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {localHistorico instanceof Array && localHistorico.length > 0 ?
                                            <></>
                                            :
                                            <TableRow>
                                                <TableCell>Nenhuma informação encontrada.</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </Box>
                        }
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

